





























import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { EmoticonEntity } from '@/entities/emoticon.entity';
import { mapActions, mapGetters } from 'vuex';
import BulletinReactionService from '@/services/bulletin-reaction.service';
import BulletinCommentReactionService from '@/services/bulletin-comment-reaction.service';
import ReactionIcon from '@/components/Helper/Icon/Svg/ReactionIcon.vue';

@Component<BulletinReactionButtonAdd>({
  components: { ReactionIcon },
  computed: {
    ...mapGetters('emoticon', ['emoticons']),
  },
  methods: {
    ...mapActions('emoticon', ['fetchEmoticons']),
  },
})
export default class BulletinReactionButtonAdd extends Vue {
  emoticons!: EmoticonEntity[];
  fetchEmoticons!: () => Promise<void>;

  @Prop()
  service: BulletinCommentReactionService | BulletinReactionService;

  @Prop({ type: [String, Number] })
  commentId: string | number;

  @Prop({ type: [String, Number] })
  bulletinId: string | number;

  async mounted() {
    if (this.emoticons.length === 0) {
      await this.fetchEmoticons();
    }
  }

  /**
   * Use to Reaction for bullet or bullet's comment
   * @param id 
   */
  async createReaction(id: number) {
    if (this.service instanceof BulletinCommentReactionService) {
      await this.service.createOne({
        emoticonId: id,
        commentId: this.commentId as number,
      });
    } else {
      await this.service.createOne({
        emoticonId: id,
        bulletinId: this.bulletinId as number,
      });
    }
  }
}
